import React from "react";
import Hero1 from "../imgs/hero/hero-image1.png";
import Hero2 from "../imgs/hero/hero-image2.png";

const SupportHero = () => {
  return (
    <div className="max-w-7xl mx-auto px-1 md:px-6 lg:px-8 flex justify-between items-center relative pt-20">
      <img
        src={Hero1}
        className="hidden lg:flex absolute left-2 left-img"
        height={130}
        width={130}
      />
      <img
        src={Hero2}
        className="hidden lg:flex absolute right-2 right-img"
        height={130}
        width={130}
      />

      <div className="max-w-4xl mx-auto px-4 sm:px-12 lg:px-16 flex flex-col items-center justify-center space-y-6">
        <h1 className="text-black font-black text-3xl lg:text-6xl text-center">
          Thank You For
          <br />
          <span className="font-black text-[#3BF5CA]">Supporting Us</span>
        </h1>

        <div className="bg-[#052035] py-3 px-4 rounded-full text-sm text-center text-white">
          We love you ❤️
        </div>
      </div>
    </div>
  );
};

export default SupportHero;
